<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			v-if="type !== 'fill'"
			d="M3.58447 12.235L12 20.6505L20.4155 12.235C22.5282 10.1223 22.5282 6.69709 20.4155 4.58447C18.3029 2.47184 14.8777 2.47184 12.765 4.58447L12 5.34952L11.235 4.58447C9.12233 2.47184 5.69709 2.47184 3.58447 4.58447C1.47184 6.69709 1.47184 10.1223 3.58447 12.235Z"
			:stroke="props.iconColor"
			stroke-width="1.2"
			stroke-linejoin="round"
		/>
		<path
			v-else
			d="M3.58447 12.235L12 20.6505L20.4155 12.235C22.5282 10.1223 22.5282 6.69709 20.4155 4.58447C18.3029 2.47184 14.8777 2.47184 12.765 4.58447L12 5.34952L11.235 4.58447C9.12233 2.47184 5.69709 2.47184 3.58447 4.58447C1.47184 6.69709 1.47184 10.1223 3.58447 12.235Z"
			:fill="props.iconColor"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
		type?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
		type: 'fill',
	}
);
</script>

<style lang="scss" scoped></style>
